/**
 * The configuration file for the config.ts file upgrading to Angular 15.
 */

export const srcTsConfigLibProdReplaces = {
    '"enableIvy": false': '"compilationMode": "partial"'
};

export const srcTsConfigSpecRemoves = [
    {
        key: '"files": [',
        linesInTotalAfterKey: 4,
        exactMatch: false
    },
];
